import { Button, Image } from "antd";
import { doSignOut, images_folder } from "./client";
import { MenuFoldOutlined, LogoutOutlined } from "@ant-design/icons";

const DashboardMenu = (props) => {
  return (
    <>
      <h3 className="dash-message hide-x-mobile">{props.welcomeMessage}</h3>
      <Image
        className="hide-x-large"
        width={50}
        preview={false}
        src={images_folder(props.applicationHeader.logo)}
      />
      <h3
        style={{ display: "inline", paddingLeft: "15px" }}
        className="hide-x-large"
      >
        {props.applicationHeader.text}
      </h3>
      <div className="dash-btns">
        <Button onClick={doSignOut} size="medium" className="hide-x-mobile">
          <LogoutOutlined /> Sign Out
        </Button>
        <Button
          className="hide-x-large"
          onClick={() => {
            props.setOpenMobileMenu(true);
          }}
          icon={<MenuFoldOutlined />}
        >
          {" "}
          Menu
        </Button>
      </div>
    </>
  );
};

export default DashboardMenu;
